"use strict";

(function () {
  'use strict';

  function tripCardCtrl() {
    var vm = this;

    this.$onInit = function () {//console.log(this);
    };
  }

  tripCardCtrl.$inject = [];
  angular.module('trip-card', []).component('tripCard', {
    bindings: {
      transactionId: '@',
      adminCustDataId: '@',
      destination: '@',
      startDate: '@',
      endDate: '@',
      nights: '@',
      guests: '@',
      propertyName: '@',
      propertyImage: '@',
      managerName: '@',
      managerLogo: '@',
      relativeText: '@',
      status: '@'
    },
    controller: tripCardCtrl,
    templateUrl: 'components/trip-card/trip-card.html'
  }).component('tripCardLoading', {
    templateUrl: 'components/trip-card/trip-card-loading.html'
  });
})();